import { render, staticRenderFns } from "./salesSummaryPayType.vue?vue&type=template&id=1c974538&scoped=true&"
import script from "./salesSummaryPayType.vue?vue&type=script&lang=js&"
export * from "./salesSummaryPayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c974538",
  null
  
)

export default component.exports